import { Context } from "@nuxt/types/app";

// $moduleType
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function regexListingChecker(
    path: string,
    module: string,
    listingType?: string,
  ): boolean {
    let regex = new RegExp(`^.*/${module}/?$`, "i");
    if (listingType) {
      regex = new RegExp(`^.*/${module}/${listingType}/?$`, "i");
    }
    return regex.test(path);
  }

  return {
    regexListingChecker,
  };
}
